import { Pipe, PipeTransform } from '@angular/core';

import { Participant, Room } from '@shared/factories';

const AVATAR_COLORS = ['bg-blue', 'bg-dark-blue', 'bg-purple', 'bg-dark-green', 'bg-dark-orange', 'bg-dark-red', 'bg-dark-purple', 'bg-secondary'];

@Pipe({
  name: 'avatarColor',
  standalone: false
})
export class AvatarColorPipe implements PipeTransform {

  transform(value: Room | Participant): string {
    let key = (value as Room)?.owner?.userId || (value as Participant)?.userId || value?.id || 0;
    return AVATAR_COLORS[key % AVATAR_COLORS.length];
  }
}
